import { isEmpty } from 'lodash';
import { ACTION_TYPES as TASKS_ACTION_TYPES } from '../tasks/constants';

const assigneesReducer = (state = {}, action) => {
  switch (action.type) {
    case TASKS_ACTION_TYPES.GET_TASKS_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_TASKS_INFINITE_LIST_NEXT_PAGE_SUCCESS:
    case TASKS_ACTION_TYPES.GET_SECTION_TASKS_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_TASK_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_TASK_BY_IDENTIFIER_LEAN_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.ADD_TASK_SUCCESS:
    case TASKS_ACTION_TYPES.GET_USER_TASKS_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.GET_DASHBOARD_TASKS_REQUEST_SUCCESS:
    case TASKS_ACTION_TYPES.UPDATE_TASK_EVENT:
    case TASKS_ACTION_TYPES.ADD_TASK_EVENT:
    case TASKS_ACTION_TYPES.MERGE_CHART_PREVIEW_TASKS: {
      const updatedState = {};

      if (!isEmpty(action?.payload?.assignees)) {
        Object.keys(action?.payload?.assignees).forEach(assigneeId => {
          const assignee = action?.payload?.assignees?.[assigneeId];
          updatedState[assigneeId] = {
            ...(state?.[assigneeId] || {}),
            ...assignee
          }
        })
      }
      if (!isEmpty(action?.payload?.users)) {
        Object.keys(action?.payload?.users).forEach(userId => {
          const user = action?.payload?.users?.[userId];
          updatedState[userId] = {
            ...(state?.[userId] || {}),
            ...(updatedState?.[userId] || {}),
            ...user
          }
        })
      }
      return {
        ...state,
        ...updatedState,
      };
    }
    case TASKS_ACTION_TYPES.EDIT_TASK: {
      if (isEmpty(action?.payload?.dataToUpdate?.assignee)) {
        return state;
      }

      const updatedState = {};

      action?.payload?.dataToUpdate?.assignee?.forEach(assignee => {
        const assigneeId = assignee?.assigneeId?._id;
        updatedState[assigneeId] = {
          ...(state?.[assigneeId] || {}),
          ...(assignee?.assigneeId || {})
        }
      })

      return {
        ...state,
        ...updatedState,
      };
    }
    default: {
      return state;
    }
  }
};

export default assigneesReducer;
